import { Row, Col, Tab, Nav } from "react-bootstrap";
import AdminHeader from './AdminHeader';
import UsersTable from './UsersTable';
import Invitations from './Invitations';

function AdminDashboard() {
  return (
    <div>
      <AdminHeader />
      <Tab.Container id="admin_dashboard_tabs" defaultActiveKey="paid_users" mountOnEnter unmountOnExit>
        <Row>
          <Col xs={6} md={2} style={{height: "750px", "background-color": "#dee8faff", "padding-left": "50px"}}>
            <Nav variant="pills" className="flex-column mt-2">
              <Nav.Item>
                <Nav.Link eventKey="paid_users">Profiles</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="invitations">Invite Learners</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="purchases" disabled>Purchases</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="content_management" disabled>Content Management</Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>
          <Col md={10} className="d-flex flex-column">
            <Tab.Content>
              <Tab.Pane eventKey="paid_users">
                <UsersTable />
              </Tab.Pane>
              <Tab.Pane eventKey="invitations">
                <Invitations />
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </div>
  );
};

export default AdminDashboard;
